import { State } from 'src/types'
import { indexFingerCover } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/indexFinger'
import {
  indexFingerPad,
  indexFingerPadOfFType,
  indexFingerPadWithNoEdge
} from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/indexFingerPad'

export const fingerGuardDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const printLeatherTypeValue = state.printLeatherType?.value
  switch (state.fingerGuardType.value) {
    case 'indexPadWithNoEdge':
      // ヘリ無し指当て
      await indexFingerPadWithNoEdge(ctx, state.indexCover.color, state.stitch.color, printLeatherTypeValue)
      break
    case 'indexCover':
      // 指カバー
      await indexFingerCover(ctx, state.indexCover.color, state.stitch.color, printLeatherTypeValue)
      break
    case 'indexPad':
      // 指当て
      await indexPadSwitcher(ctx, state)
      break
  }
}

const indexPadSwitcher = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const printLeatherTypeValue = state.printLeatherType?.value
  switch (state.baseModel.brand) {
    default:
      await indexFingerPad(ctx, state.indexCover.color, state.stitch.color, printLeatherTypeValue)
      break
  }
}
